import { gql } from '@apollo/client';

export default gql`
  fragment Document on Document {
    _id
    name
    enabled
    url
    subject
  }
`;
